<template>
  <div class="warehousing-detail">
    <el-form
      ref="form"
      :model="form"
      label-width="100px"
      label-position="right"
      :show-message="false"
    >
      <el-collapse :value="collapse">
        <!--工作号信息-->
        <div class="section" style="width:90%; min-width:1200px">
          <span class="title">{{ $t('Warehouse.JobNumberInformation') }}</span>
          <div class="form-row" style="display:flex;flex-direction:row;">
            <el-form
              label-width="100px"
              label-position="right"
              :disabled="true"
              style="margin-right:10px"
            >
              <el-form
                :disabled="true"
                class="section"
                style="flex-direction: row;width:90%;min-width:1200px"
              >
                <span style="display: flex;align-items: center;width: 64px">
                  {{ $t('FbaJob.ValueAddedServices') }}
                </span>
                <el-checkbox-group v-model="selectedLocalAddedService">
                  <el-checkbox
                    v-for="item in localAddedService"
                    :key="item.code"
                    :label="item.code"
                    style="margin-left: 8px;margin-right: 8px"
                  >
                    {{ item.chineseName }}
                  </el-checkbox>
                  <el-checkbox v-model="form.destinationPortService" style="margin-left: 8px;margin-right: 8px" no="destinationPortService">{{ $t('SeaExport.PortOfDestinationServices') }}</el-checkbox>
                </el-checkbox-group>
              </el-form>
              <el-row>
                <el-col :span="4.8">
                  <!-- 业务编号-->
                  <el-form-item :label="$t('SeaExport.BusinessNo')" prop="jobNo">
                    <el-input v-model="form.jobNo" no="jobNo" />
                  </el-form-item>
                  <!-- 海外仓(FBA FC)-->
                  <el-form-item :label="$t('CargoMsg.Cargo_Destination')" prop="warehouseCode">
                    <div style="display: flex;">
                      <el-tooltip :content="form.warehouseCode" placement="bottom-end">
                        <el-cascader
                          v-model="form.warehouseCode"
                          no="warehouseCode"
                          style="width: 91px; padding-right: 2px;"
                          :options="destinations"
                          filterable
                          :clearable="true"
                          @focus="JobUtils.focusWarehouseCode(form)"
                          @blur="JobUtils.blurWarehouseCode(form)"
                          @change="p=>{JobUtils.warehouseCodeHandler(form, p);}"
                        />
                      </el-tooltip>
                      <el-checkbox v-model="form.remoteWarehouse" no="remoteWarehouse">{{ $t('Warehouse.RemoteWarehouse') }}</el-checkbox>
                    </div>
                  </el-form-item>
                  <!-- 国外仓-->
                  <el-form-item :label="'国外仓'">
                    <cargo-advance-select
                      no="overseaWarehouseCode"
                      :select-type="selectTypeNames.basic_data_OverseaWarehouse"
                      filterable
                      :method-params="{ifFba:false}"
                      :clearable="false"
                      tag-name="countryChineseName"
                      tag-value="warehouseCode"
                      :default-value="form.overseaWarehouseCode"
                      style="width:100%;"
                      @parentCallBack="p=>{form.overseaWarehouseCode=p.value}"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="4.8">
                  <!-- 委托单位-->
                  <el-form-item :label="$t('SeaExport.ConsignationCompany')" prop="customerId">
                    <cargo-company-select
                      no="customerId"
                      :method-params="{customer:true,active:true}"
                      :default-value="form.customerId||''"
                    />
                  </el-form-item>
                  <!-- 目的国-->
                  <el-form-item :label="$t('Warehouse.DestinationCountry')" prop="destinationCountry">
                    <el-input v-model="form.country" no="destinationCountry" />
                  </el-form-item>
                  <!-- 计费方式-->
                  <el-form-item :label="$t('FbaJob.ChargingMethod')">
                    <el-radio-group v-model="form.chargingMethod">
                      <el-radio :label="'0'">{{ 'KG' }}</el-radio>
                      <el-radio :label="'1'">{{ 'CBM' }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="4.8">
                  <!-- PO原单号-->
                  <el-form-item :label="$t('Warehouse.PoOriginalOrderNo')" prop="poNumber">
                    <el-input v-model="form.poNumber" no="poNumber" />
                  </el-form-item>
                  <!-- 邮编-->
                  <el-form-item :label="$t('SeaExport.ZIP')" prop="zip">
                    <el-input v-model="form.zipCode" no="zip" />
                  </el-form-item>
                  <!-- 计泡系数-->
                  <el-form-item :label="$t('FbaChannel.bubbleCountingRatio')">
                    <el-input v-model="form.bubbleCountingRatio" />
                  </el-form-item>
                </el-col>
                <el-col :span="4.8">
                  <!-- 服务渠道-->
                  <el-form-item :label="$t('Warehouse.ServiceChannel')" prop="serviceChannel">
                    <el-input v-model="form.serviceChannel" no="serviceChannel" />
                  </el-form-item>
                  <!-- 目的地派送方式-->
                  <el-form-item :label="$t('Warehouse.DestinationDeliveryMethod')" prop="deliveryMethod">
                    <cargo-advance-select
                      no="destinationDistribution"
                      :select-type="selectTypeNames.local_cache_FbaJobConstants$ORDER_DESTINATION_DISTRIBUTION_TYPES"
                      filterable
                      :clearable="false"
                      :default-value="form.destinationDistribution"
                      @parentCallBack="p=>{form.destinationDistribution=p.value}"
                    />
                  </el-form-item>
                  <!-- 分泡比例-->
                  <el-form-item label="分泡比例">
                    <el-input-number v-model="form.bubbleSplittingRatio" style="width: 100px;" controls-position="right" :max="100" :min="0" :precision="0" />%
                  </el-form-item>
                </el-col>
                <el-col :span="4.8">
                  <!-- 运输方式-->
                  <el-form-item :label="$t('Pricing.TransportMode')" prop="shippingType">
                    <cargo-advance-select
                      no="shippingType"
                      :select-type="selectTypeNames.local_cache_FbaJobConstants$SHIPPING_TYPES"
                      filterable
                      :clearable="false"
                      :default-value="form.shippingType"
                      @parentCallBack="p=>{form.shippingType=p.value;}"
                    />
                  </el-form-item>
                  <!-- 快递公司-->
                  <el-form-item v-if="form.destinationDistribution && Number(form.destinationDistribution) === 1" :label="$t('Warehouse.CourierServicesCompany')" prop="courierServicesCompany">
                    <el-input v-model="form.expressCompany" no="courierServicesCompany" />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
        <!--仓库信息-->
        <div class="section" style="width:90%; min-width:1200px">
          <span class="title">{{ $t('Warehouse.WarehouseInformation') }}</span>
          <div class="form-row" style="display:flex;flex-direction:row;">
            <el-form
              label-width="110px"
              label-position="right"
              style="margin-right:10px"
            >
              <el-row>
                <el-col :span="4.8">
                  <el-form-item
                    class="required"
                    :label="$t('Warehouse.WarehouseNo')"
                    prop="warehouseNo"
                  >
                    <el-input v-model="form.warehouseNo" style="width:95%;" :disabled="true" @change="warehouseNoChargeHandler" />
                  </el-form-item>
                  <!--                  <el-form-item
                    :label="$t('Warehouse.ReceiptNo')"
                    prop="receiptNo"
                    class="auto-width"
                  >
                    <el-input v-model="form.receiptNo" style="width:95%;" :disabled="!isEditing" />
                  </el-form-item>-->
                  <el-form-item
                    :label="$t('Warehouse.WarehouseName')"
                    prop="warehouse"
                    class="auto-width required"
                  >
                    <cargo-advance-select
                      no="warehouse"
                      :disabled="!isEditing"
                      :select-type="selectTypeNames.basic_data_OverseaWarehouse"
                      filterable
                      :method-params="{ifFba:false}"
                      :clearable="false"
                      tag-name="countryChineseName"
                      tag-value="warehouseCode"
                      :default-value="form.warehouse"
                      style="width:95%;"
                      @parentCallBack="p=>{form.warehouse=p.value}"
                    />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.Warehouseman')"
                    prop="warehouseOp"
                    class="auto-width"
                  >
                    <cargo-user-select
                      :method-params="{officeId:form.opOffice,category:'role',shape:'warehouseOp'}"
                      :default-value="form.warehouseOp||''"
                      :disabled="!isEditing"
                      style="width:95%;"
                      @change="p=>{form.warehouseOp=p.value}"
                    />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.WarehouseLocation')"
                    prop="location"
                    class="auto-width"
                  >
                    <el-input v-model="form.location" style="width:95%;" :disabled="!isEditing" />
                  </el-form-item>
                  <el-form-item
                    class="required"
                    :label="$t('Warehouse.StorageDate')"
                    prop="warehouseInDate"
                  >
                    <el-date-picker
                      v-model="form.warehouseInDate"
                      type="datetime"
                      :disabled="true"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      format="yyyy-MM-dd HH:mm"
                      style="width: 95%;"
                    />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.DeliveryDate')"
                    prop="warehouseOutDate"
                    class="auto-width"
                  >
                    <el-date-picker
                      v-model="form.warehouseOutDate"
                      type="datetime"
                      :disabled="true"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      format="yyyy-MM-dd HH:mm"
                      style="width: 95%;"
                    />
                  </el-form-item>
                  <!--                  <el-form-item
                    :label="$t('Warehouse.DeliveryMode')"
                    prop="outType"
                    class="auto-width"
                  >
                    <el-select
                      v-model="form.outType"
                      clearable
                      style="width: 95%;"
                      :disabled="!isEditing"
                      :placeholder="$t('Message.PleaseSelect')"
                      size="mini"
                    >
                      <el-option
                        v-for="(item,index) in WarehouseInState.WAREHOUSE_IN_OUT_TYPE"
                        :key="index"
                        :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                        :value="item.code"
                      />
                    </el-select>
                  </el-form-item>-->
                </el-col>
                <el-col :span="4.8">
                  <el-form-item
                    prop="isPallet"
                  >
                    <el-checkbox v-model="form.pallet" :disabled="!isEditing" @change="daycareInformationChangeHandler">{{ $t('Warehouse.DaycareInformation') }}
                    </el-checkbox>
                  </el-form-item>
                  <!--                  <el-form-item
                    prop="isSealCargo"
                  >
                    <el-checkbox v-model="form.sealCargo" :disabled="!isEditing">{{ $t('Warehouse.IsTheGoodsClosed') }}</el-checkbox>
                  </el-form-item>-->
                  <el-form-item
                    :label="$t('Warehouse.PalletSum')"
                    prop="palletSum"
                  >
                    <el-input-number v-model="form.palletSum" :disabled="true" controls-position="right" :max="10" :min="0" style="width:95%;" :precision="0" />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.DeliveryCmp')"
                    prop="DeliveryCmp"
                  >
                    <el-input v-model="form.deliveryCmp" style="width:95%;" :disabled="!isEditing" />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.LicensePlate')"
                    prop="licensePlate"
                  >
                    <el-input v-model="form.truckNo" style="width:95%;" :disabled="!isEditing" />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.Driver')"
                    prop="licensePlate"
                  >
                    <el-input v-model="form.driver" style="width:95%;" :disabled="!isEditing" />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.DriverPhone')"
                    prop="licensePlate"
                  >
                    <el-input v-model="form.driverTel" style="width:95%;" :disabled="!isEditing" />
                  </el-form-item>
                </el-col>
                <el-col :span="4.8">
                  <el-form-item
                    prop="isBroken"
                  >
                    <el-checkbox v-model="form.broken" :disabled="!isEditing" @change="checkboxChangeHandler">{{ $t('Warehouse.IsNotComputationIsAffectedByDampness') }}
                    </el-checkbox>
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.ComputationIsAffectedByDampnessNum')"
                    prop="brokenNum"
                  >
                    <el-input-number v-model="form.brokenQuantity" :min="0" :max="99999" controls-position="right" style="width:95%;" :precision="0" :disabled="!(isEditing && form.broken)" />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.DescriptionOfGoods')"
                    prop="licensePlate"
                  >
                    <el-input v-model="form.brokenDes" class="custom-textarea" type="textarea" :row="3" style="width:95%;height: 64px" :disabled="!isEditing" />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.HandlingOpinions')"
                    prop="licensePlate"
                  >
                    <el-input v-model="form.comments" class="custom-textarea" type="textarea" :row="3" style="width:95%;height: 64px" :disabled="!isEditing" />
                  </el-form-item>
                </el-col>
                <el-col :span="4.8">
                  <el-form-item
                    prop="receiveDc"
                  >
                    <el-checkbox v-model="form.receiveDc" :disabled="!isEditing">{{ $t('Warehouse.ReceiveDc') }}</el-checkbox>
                  </el-form-item>
                  <el-form-item :label="$t('FbaJob.OperationStatusOfForeignWarehouse')" prop="outWarehouseStatus">
                    <el-select v-model="form.outWarehouseStatus" no="outWarehouseStatus" style="width: 95%;" placeholder="" disabled>
                      <el-option
                        v-for="item in FbaJobConstants.OVERSEA_WAREHOUSE_STATUS"
                        :key="item.code"
                        :label="item.chineseName"
                        :value="item.code"
                      />
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('Warehouse.FaceOrderPrintTime')" prop="faceOrderPrintTime">
                    <el-date-picker
                      v-model="form.faceOrderPrintTime"
                      type="datetime"
                      :disabled="!isEditing"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      format="yyyy-MM-dd HH:mm"
                      style="width: 95%;"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('Warehouse.CourierNumber')" prop="courierNumber" class="auto-width">
                    <el-input v-model="form.courierNumber" style="width:95%;" :disabled="!isEditing" />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.Remark')"
                    prop="licensePlate"
                  >
                    <el-input v-model="form.remarks" class="custom-textarea" type="textarea" :row="3" style="width:95%;height: 64px" :disabled="!isEditing" />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
        <!--货物明细-->
        <div class="section" style="width:90%; min-width:1200px">
          <span class="title">{{ $t('Warehouse.CargoDetails') }}</span>
          <div class="form-row grid-list">
            <el-form
              label-width="100px"
              label-position="left"
              :disabled="!isEditing"
              style="margin-right:10px"
            >
              <div>
                <!--                <el-form class="spacing">
                  <el-button type="primary" :disabled="!isEditing" @click="addDetailHandler">{{ $t('Warehouse.AddCargo') }}</el-button>
                  <el-button type="primary" :disabled="!isEditing" @click="batchMaintenance">{{ $t('Warehouse.BatchMaintenance') }}</el-button>
                  <el-button type="primary" :disabled="!isEditing" @click="batchImport">{{ $t('CargoMsg.Cargo_Import2') }}</el-button>
                  <el-button type="primary" :disabled="!isEditing" @click="pickingGoods">{{ $t('Warehouse.PickingGoods') }}</el-button>
                  <el-button type="primary" :disabled="!isEditing" @click="adjustChargeWeight">{{ $t('Warehouse.AdjustChargeWeight') }}</el-button>
                  <el-button type="danger" :disabled="!isEditing" @click="clearData">{{ $t('CargoMsg.Cargo_Empty') }}</el-button>
                  <el-button type="danger" :disabled="!isEditing" @click="delDetailHandler">{{ $t('Warehouse.DeleteCargo') }}</el-button>
                </el-form>-->
                <cargo-ag-grid
                  ref="goodsTableAct"
                  config-module="9300010"
                  :grid-options="detailList.goodGridOptions"
                  :column-defs="detailList.goodsColumn"
                  :row-data="form.warehouseInDetailList || []"
                  style="height: 200px;min-width:1150px"
                  @gridReady="params=>{detailList.gridApi=params.api}"
                />
                <el-form-item class="auto-width">
                  <div style="display: flex;text-align: left" class="title-row">
                    <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:80px;text-align: right;">{{ $t('SeaExport.Quantity') }}</div>
                    <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:150px;text-align: right;">{{ $t('SeaExport.Weight2') }} KGS</div>
                    <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:120px;text-align: right;">{{ $t('SeaExport.Cubage') }} CBM</div>
                    <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:120px;text-align: right;">{{ $t('SeaExport.VolumetricWeight') }} KGS</div>
                    <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:150px;text-align: right;">{{ $t('SeaExport.ChargedWeight') }} M/T</div>
                  </div>
                </el-form-item>
                <el-form-item :label="$t('SeaExport.Actual')" class="auto-width">
                  <el-input-number v-model="form.quantitySum" :disabled="true" controls-position="right" :min="0" :max="999999999" :precision="0" />
                  <el-input-number v-model="form.weightSum" :disabled="true" controls-position="right" :precision="2" :min="0" :max="999999999" />
                  <el-input-number v-model="form.cubageSum" :disabled="true" controls-position="right" :precision="3" :min="0" :max="999999999" />
                  <el-input-number v-model="form.volumetricWeightAct" :disabled="true" controls-position="right" :precision="3" :min="0" :max="999999999" />
                  <el-input-number v-model="form.chargeWeightAct" :disabled="true" controls-position="right" :precision="3" :min="0" :max="999999999" />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.Consignation')" class="auto-width">
                  <el-input-number v-model="form.quantityContract" :disabled="true" controls-position="right" :min="0" :max="999999999" :precision="0" />
                  <el-input-number v-model="form.weightContract" :disabled="true" controls-position="right" :precision="2" :min="0" :max="999999999" />
                  <el-input-number v-model="form.cubageContract" :disabled="true" controls-position="right" :precision="3" :min="0" :max="999999999" />
                  <el-input-number v-model="form.volumetricWeightContract" :disabled="true" controls-position="right" :precision="3" :min="0" :max="999999999" />
                  <el-input-number v-model="form.chargeWeightContract" :disabled="true" controls-position="right" :precision="3" :min="0" :max="999999999" />
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
        <!--货物照片-->
        <div class="section" style="width:90%; min-width:1200px">
          <span class="title">{{ $t('Warehouse.CargoPhotos') }}</span>
          <div class="form-row grid-list">
            <el-form
              label-width="100px"
              label-position="left"
              :disabled="!isEditing"
              style="margin-right:10px"
            >
              <el-form class="spacing">
                <el-upload
                  :action="`${URL.warehouseIn.uploadFileForWarehouseIn}?warehouseInUuid=${warehouseInUuid}`"
                  :headers="{sessionId:$store.getters.token}"
                  :show-file-list="false"
                  :on-success="uploadSuccess"
                  :on-change="toChooseFile"
                  :disabled="!isEditing"
                  style="display: inline-block;margin-right: 5px;"
                >
                  <el-button type="primary" :disabled="!isEditing">{{ $t('Warehouse.SelectFile') }}</el-button>
                </el-upload>
                <el-button type="danger" :disabled="!isEditing" @click="delPhotoHandler">{{ $t('Warehouse.DeleteFile') }}</el-button>
              </el-form>
              <cargo-ag-grid
                ref="photosList"
                config-module="9300013"
                :grid-options="photoList.gridOptions"
                :column-defs="photoList.photoColumn"
                :row-data="form.businessDocumentVOList || []"
                style="height: 200px;min-width:1150px"
                @gridReady="params=>{photoList.gridApi=params.api}"
              />
            </el-form>
          </div>
        </div>
        <!-- 操作要求 -->
        <div class="section" style="width:90%; min-width:1200px">
          <span class="title">{{ $t('Warehouse.OperationRequirements') }}</span>
          <div class="form-row grid-list">
            <el-form
              label-width="100px"
              label-position="left"
              :disabled="!isEditing"
              style="margin-right:10px"
            >
              <div>
                <cargo-ag-grid
                  ref="opList"
                  config-module="9300004"
                  :grid-options="opList.options"
                  :column-defs="opList.opColumn"
                  :row-data="form.operationRequirementVOList || []"
                  style="height: 200px;min-width:1150px"
                  @gridReady="params=>{opList.gridApi=params.api}"
                />
              </div>
            </el-form>
          </div>
        </div>
      </el-collapse>
    </el-form>

    <!-- 文件类型选择对话框 -->
    <mx-file-type-editor
      v-if="fileTypeEditor.visible"
      :visible.sync="fileTypeEditor.visible"
      :lob="fileTypeEditor.lob"
      :file-id="fileTypeEditor.fileId"
      :file-category="fileTypeEditor.fileCategory"
      @saveFileType="itemEditEndHandler"
    />
    <!-- 选择业务弹框 -->
    <job-nos-window
      v-if="jobNosWindow.visible"
      :visible.sync="jobNosWindow.visible"
      :job-nos="jobNosWindow.jobs"
      @selectJobNoHandler="selectJobNoHandler"
    />
  </div>
</template>
<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import URL from '@/api/urlTranslator'
import { getLoading } from '@/utils/utilBaseElement'
import { getJobDetailFunc, queryJobByWarehouseNoFunc } from '@/api/warehouseIn/warehouseIn'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import CargoDateTimePicker from '@/components/Cargo/Common/CargoDateTimePicker'
import * as WarehouseInState from '@/class/cargo/model/parameters/WarehouseInState'
import { cache, cacheName } from '@/utils/cacheManager'
import MxFileTypeEditor from '@/components/Cargo/Job/mxFileTypeEditor'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import JobNosWindow from '@/components/Cargo/Warehouse/components/warehousing/jobNosWindow'
import { DocumentTypeUtil } from '@/class/cargo/model/utils/DocumentTypeUtil'
import CargoAgGridColumnEditGroup from '@/components/Cargo/Common/CargoAgGridColumnEditGroup'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { WarehouseIn } from '@/class/model/booking/WarehouseIn'
import { FbaWarehouseInDetail } from '@/class/model/booking/FbaWarehouseInDetail'
import * as FbaJobConstants from '@/class/cargo/model/parameters/FbaJobConstants'
import ColumnUtils from '@/utils/ColumnUtils'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { getSpecificBasicDataFromCache } from '@/utils/basicDataCache'

export default {
  name: 'FbaOverseaWarehousingDetail',
  components: {
    JobNosWindow,
    cargoAdvanceSelect,
    cargoUserSelect,
    cargoCompanySelect,
    MxFileTypeEditor,
    CargoDateTimePicker
  },
  props: {
    warehouseInUuid: { type: String, default: () => '' },
    action: { type: String, required: true },
    lob: { type: String, required: true }
  },
  data() {
    return {
      FbaJobConstants,
      SystemConstants,
      WarehouseInState,
      documentTypeUtil: null,
      selectTypeNames: TYPE_NAMES,
      URL,
      storageURL: '',
      filter: {},
      addCargoVisible: false,
      gridApi: null,
      fileTypeEditor: {
        visible: false,
        fileId: '',
        lob: 'SE',
        fileCategory: ''
      },
      jobNosWindow: {
        visible: false,
        jobs: []
      },
      fileTypeMap: {},
      jobKeyOld: '',
      bubbleCountingRatio: 0.0,
      selectedLocalAddedService: [],
      localAddedService: [],
      selectedPodAddedService: [],
      podAddedService: [],
      form: new WarehouseIn().fillDefaultValue().getData(),
      detailList: {
        gridApiEst: null,
        goodGridOptionsEst: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          selectedRowIndex: -1,
          singleClickEdit: true,
          onCellFocused: event => {
            this.detailList.goodGridOptionsEst.selectedRowIndex = event.rowIndex
          }
        },
        goodsColumnEst: [
          {
            headerName: this.$t('Warehouse.ContainerNo'), field: 'containerNo', colId: 'containerNo', minWidth: 150
          }, {
            headerName: 'Shipment Id', field: 'shipmentId', colId: 'shipmentId', minWidth: 150
          }, {
            headerName: 'Reference Id', field: 'referenceId', colId: 'referenceId', minWidth: 150
          }, {
            headerName: this.$t('Warehouse.BoxesNumber'), field: 'boxesNumber', colId: 'boxesNumber', minWidth: 150,
            cellStyle: (params) => {
              const current = params.data
              const warehouseInDetailList = this.form.warehouseInDetailList || []
              const equal = this.compareEstWarehouseInField('boxHeight', current, warehouseInDetailList)
              if (!equal) {
                return { color: 'red' }
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0')
            }
          }, {
            headerName: this.$t('Warehouse.SingleBoxWeight'), field: 'singleBoxWeight', colId: 'singleBoxWeight', minWidth: 150,
            cellStyle: (params) => {
              const current = params.data
              const warehouseInDetailList = this.form.warehouseInDetailList || []
              const equal = this.compareEstWarehouseInField('boxHeight', current, warehouseInDetailList)
              if (!equal) {
                return { color: 'red' }
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: this.$t('Warehouse.BoxLength'), field: 'boxLength', colId: 'boxLength', minWidth: 150,
            cellStyle: (params) => {
              const current = params.data
              const warehouseInDetailList = this.form.warehouseInDetailList || []
              const equal = this.compareEstWarehouseInField('boxHeight', current, warehouseInDetailList)
              if (!equal) {
                return { color: 'red' }
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: this.$t('Warehouse.BoxWidth'), field: 'boxWidth', colId: 'boxWidth', minWidth: 150,
            cellStyle: (params) => {
              const current = params.data
              const warehouseInDetailList = this.form.warehouseInDetailList || []
              const equal = this.compareEstWarehouseInField('boxHeight', current, warehouseInDetailList)
              if (!equal) {
                return { color: 'red' }
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: this.$t('Warehouse.BoxHeight'), field: 'boxHeight', colId: 'boxHeight', minWidth: 150,
            cellStyle: (params) => {
              const current = params.data
              const warehouseInDetailList = this.form.warehouseInDetailList || []
              const equal = this.compareEstWarehouseInField('boxHeight', current, warehouseInDetailList)
              if (!equal) {
                return { color: 'red' }
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_EnglishCargoName'), field: 'cargoEnglishName', colId: 'cargoEnglishName', minWidth: 150
          }, {
            headerName: this.$t('CargoMsg.Cargo_ChineseCargoName'), field: 'cargoChineseName', colId: 'cargoChineseName', minWidth: 150
          }, {
            headerName: this.$t('Warehouse.UnitRate'), field: 'unitRate', colId: 'unitRate', minWidth: 150,
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: this.$t('Warehouse.Quantity'), field: 'quantity', colId: 'quantity', minWidth: 150,
            valueFormatter: params => {
              return this.$numeral(params.value).format('0')
            }
          }, {
            headerName: this.$t('Warehouse.HsCode'), field: 'hsCode', colId: 'hsCode', minWidth: 150
          }, {
            headerName: this.$t('Warehouse.Brand'), field: 'brand', colId: 'brand', minWidth: 150
          }, {
            headerName: this.$t('Warehouse.BrandType'), field: 'brandType', colId: 'brandType', minWidth: 150
          }, {
            headerName: this.$t('Warehouse.ModelNo'), field: 'modelNo', colId: 'modelNo', minWidth: 150
          }, {
            headerName: 'SKU NO', field: 'skuNo', colId: 'skuNo', minWidth: 150
          }, {
            headerName: this.$t('Warehouse.MaterialQuality'), field: 'materialQuality', colId: 'materialQuality', minWidth: 150
          }, {
            headerName: this.$t('Warehouse.Purpose'), field: 'purpose', colId: 'purpose', minWidth: 150
          }, {
            headerName: this.$t('Warehouse.SalesLink'), field: 'salesLink', colId: 'salesLink', minWidth: 150
          }, {
            headerName: this.$t('Warehouse.SalesPrice'), field: 'salesPrice', colId: 'salesPrice', minWidth: 150,
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: this.$t('Warehouse.PictureUrl'), field: 'pictureUrl', colId: 'pictureUrl', minWidth: 150
          }, {
            headerName: this.$t('Warehouse.WeightKg'), field: 'weight', colId: 'weight', minWidth: 150,
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: 'ASIN', field: 'asin', colId: 'asin', minWidth: 150
          }, {
            headerName: this.$t('Warehouse.CargoType'), field: 'cargoType', colId: 'cargoType', minWidth: 150,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoType, 'code', params.value, 'chineseName')
            }
          }, {
            headerName: this.$t('Warehouse.ProductDescription'), field: 'productDescription', colId: 'productDescription', minWidth: 150
          }, {
            headerName: this.$t('Warehouse.PalletNo'), field: 'palletNo', colId: 'palletNo', minWidth: 150,
            cellStyle: (params) => {
              const current = params.data
              const fbaJobGoods = this.form.fbaJobGoods || []
              const equal = this.compareEstWarehouseInField('palletNo', current, fbaJobGoods)
              if (!equal) {
                return { color: 'red' }
              }
            }
          }
        ],
        gridApi: null,
        goodGridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          selectedRowIndex: -1,
          singleClickEdit: true,
          onCellFocused: event => {
            this.detailList.goodGridOptions.selectedRowIndex = event.rowIndex
          },
          // 添加编辑组件
          frameworkComponents: {
            CargoAgGridCommonInputEditor,
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridColumnEditGroup
          }
        },
        goodsColumn: [
          {
            headerName: this.$t('Warehouse.ContainerNo'), field: 'containerNo', colId: 'containerNo', minWidth: 150,
            editable: () => this.canNotEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: 'Shipment Id', field: 'shipmentId', colId: 'shipmentId', minWidth: 150,
            editable: () => this.canNotEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: 'Reference Id', field: 'referenceId', colId: 'referenceId', minWidth: 150,
            editable: () => this.canNotEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.BoxesNumber'), field: 'boxesNumber', colId: 'boxesNumber', minWidth: 150,
            editable: () => this.canNotEdit,
            cellStyle: (params) => {
              const current = params.data
              const fbaJobGoods = this.form.fbaJobGoods || []
              const equal = this.compareEstWarehouseInField('boxesNumber', current, fbaJobGoods)
              if (!equal) {
                return { color: 'red' }
              }
            },
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 0,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.SingleBoxWeight'), field: 'singleBoxWeight', colId: 'singleBoxWeight', minWidth: 150,
            editable: () => this.canNotEdit,
            cellStyle: (params) => {
              const current = params.data
              const fbaJobGoods = this.form.fbaJobGoods || []
              const equal = this.compareEstWarehouseInField('singleBoxWeight', current, fbaJobGoods)
              if (!equal) {
                return { color: 'red' }
              }
            },
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.BoxLength'), field: 'boxLength', colId: 'boxLength', minWidth: 150,
            editable: () => this.canNotEdit,
            cellStyle: (params) => {
              const current = params.data
              const fbaJobGoods = this.form.fbaJobGoods || []
              const equal = this.compareEstWarehouseInField('boxLength', current, fbaJobGoods)
              if (!equal) {
                return { color: 'red' }
              }
            },
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.BoxWidth'), field: 'boxWidth', colId: 'boxWidth', minWidth: 150,
            editable: () => this.canNotEdit,
            cellStyle: (params) => {
              const current = params.data
              const fbaJobGoods = this.form.fbaJobGoods || []
              const equal = this.compareEstWarehouseInField('boxWidth', current, fbaJobGoods)
              if (!equal) {
                return { color: 'red' }
              }
            },
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.BoxHeight'), field: 'boxHeight', colId: 'boxHeight', minWidth: 150,
            editable: () => this.canNotEdit,
            cellStyle: (params) => {
              const current = params.data
              const fbaJobGoods = this.form.fbaJobGoods || []
              const equal = this.compareEstWarehouseInField('boxHeight', current, fbaJobGoods)
              if (!equal) {
                return { color: 'red' }
              }
            },
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_EnglishCargoName'), field: 'cargoEnglishName', colId: 'cargoEnglishName', minWidth: 150,
            editable: () => this.canNotEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_ChineseCargoName'), field: 'cargoChineseName', colId: 'cargoChineseName', minWidth: 150,
            editable: () => this.canNotEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.UnitRate'), field: 'unitRate', colId: 'unitRate', minWidth: 150,
            editable: () => this.canNotEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.Quantity'), field: 'quantity', colId: 'quantity', minWidth: 150,
            editable: () => this.canNotEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 0,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.HsCode'), field: 'hsCode', colId: 'hsCode', minWidth: 150,
            editable: () => this.canNotEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.Brand'), field: 'brand', colId: 'brand', minWidth: 150,
            editable: () => this.canNotEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.BrandType'), field: 'brandType', colId: 'brandType', minWidth: 150,
            editable: () => this.canNotEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.ModelNo'), field: 'modelNo', colId: 'modelNo', minWidth: 150,
            editable: () => this.canNotEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: 'SKU NO', field: 'skuNo', colId: 'skuNo', minWidth: 150,
            editable: () => this.canNotEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: 'UPC NO', field: 'upcNo', colId: 'upcNo', minWidth: 150,
            editable: () => this.canNotEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.MaterialQuality'), field: 'materialQuality', colId: 'materialQuality', minWidth: 150,
            editable: () => this.canNotEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.Purpose'), field: 'purpose', colId: 'purpose', minWidth: 150,
            editable: () => this.canNotEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.SalesLink'), field: 'salesLink', colId: 'salesLink', minWidth: 150,
            editable: () => this.canNotEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.SalesPrice'), field: 'salesPrice', colId: 'salesPrice', minWidth: 150,
            editable: () => this.canNotEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.PictureUrl'), field: 'pictureUrl', colId: 'pictureUrl', minWidth: 150,
            editable: () => this.canNotEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.WeightKg'), field: 'weight', colId: 'weight', minWidth: 150,
            editable: () => this.canNotEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: 'ASIN', field: 'asin', colId: 'asin', minWidth: 150,
            editable: () => this.canNotEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.CargoType'), field: 'cargoType', colId: 'cargoType', minWidth: 150,
            editable: () => this.canNotEdit,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                selectType: TYPE_NAMES.basic_data_CargoType,
                methodParams: { fbaSea: true, fbaAir: true, fbaRailway: true, collectionType: 'or' },
                tagValue: 'code',
                tagName: 'chineseName',
                filterable: true
              }
            },
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoType, 'code', params.value, 'chineseName')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('FbaJob.ElectricCol'), field: 'electric', colId: 'electric', minWidth: 150,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.canNotEdit,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('FbaJob.MagneticCol'), field: 'magnetic', colId: 'magnetic', minWidth: 150,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.canNotEdit,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('FbaJob.PowderyCol'), field: 'powdery', colId: 'powdery', minWidth: 150,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.canNotEdit,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('FbaJob.LiquidCol'), field: 'liquid', colId: 'liquid', minWidth: 150,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.canNotEdit,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.ProductDescription'), field: 'productDescription', colId: 'productDescription', minWidth: 150,
            editable: () => this.canNotEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.PalletNo'), field: 'palletNo', colId: 'palletNo', minWidth: 150,
            editable: () => this.canNotEdit,
            cellStyle: (params) => {
              const current = params.data
              const fbaJobGoods = this.form.fbaJobGoods || []
              const equal = this.compareEstWarehouseInField('palletNo', current, fbaJobGoods)
              if (!equal) {
                return { color: 'red' }
              }
            },
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }
          // {
          //   headerName: '已打托箱数', field: 'palletContainerNum', colId: 'palletContainerNum', minWidth: 150,
          //   editable: () => false,
          //   cellEditor: 'CargoAgGridCommonInputEditor',
          //   cellEditorParams: {
          //     isNumber: true,
          //     inputProps: {
          //       precision: 3,
          //       max: 999999999,
          //       min: 0,
          //       controlsPosition: 'right',
          //       style: 'width: 100%; background-color:blue;'
          //     }
          //   },
          //   valueFormatter: params => {
          //     return this.$numeral(params.value).format('0')
          //   }
          // }, {
          //   headerName: '散装箱数', field: 'otherContainerNum', colId: 'otherContainerNum', minWidth: 150,
          //   editable: () => false,
          //   cellEditor: 'CargoAgGridCommonInputEditor',
          //   cellEditorParams: {
          //     isNumber: true,
          //     inputProps: {
          //       precision: 3,
          //       max: 999999999,
          //       min: 0,
          //       controlsPosition: 'right',
          //       style: 'width: 100%; background-color:blue;'
          //     }
          //   },
          //   valueFormatter: params => {
          //     return this.$numeral(params.value).format('0')
          //   }
          // }
        ]
      },
      photoList: {
        gridApi: null,
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          selectedRowIndex: -1,
          context: {
            componentParent: this
          },
          // 选中 文件类型
          onCellFocused: (event) => {
            this.onFileTypeCellFocused(event)
          },
          columnApi: null
        }, photoColumn: [
          {
            headerName: '', width: 60, checkboxSelection: true,
            sortable: false, suppressSizeToFit: true, resizable: false,
            headerCheckboxSelection: true
          },
          {
            headerName: this.$t('CargoMsg.Cargo_FileName'),
            colId: 'fileName',
            field: 'fileName',
            width: 150,
            cellRenderer: params => {
              return `<a href="${URL.common.findByFileId}/${params.data.documentId}?sessionId=${this.$store.getters.userInfo.sessionId}" target="_blank" style="color:#46a6ff">${params.value}</a>`
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_FileType'),
            colId: 'fileType',
            field: 'fileType',
            width: 150
          },
          {
            headerName: this.$t('CargoMsg.Cargo_FileSize'),
            field: 'fileSize',
            width: 200,
            cellRenderer: params => {
              return params.value ? (params.value / 1024).toFixed(1) + 'KB' : ''
            }
          },
          { headerName: this.$t('CargoMsg.Cargo_UploadTime'), colId: 'dateCreated', field: 'dateCreated', width: 150 },
          { headerName: this.$t('SeaExport.DocumentType'), colId: 'fileCategory', field: 'fileCategory', width: 150,
            cellRenderer: params => {
              return this.documentTypeUtil.fileTypeLabelFunction(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.UploadProgress'),
            colId: 'documentId',
            field: 'documentId',
            width: 115,
            cellRenderer: params => {
              if (params.value && !params.data.newData) {
                return `<span style="color:green">${this.$t('Message.Uploaded')}</span>`
              }
              if (!this.isEditing && params.data.newData) {
                return this.$t('queryJob.uploading') + '...'
              }
              return this.$t('Message.Waiting')
            }
          }
        ]
      },
      opList: {
        gridApi: null,
        options: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          columnApi: null,
          context: {
            componentParent: this
          }
        },
        opColumn: [
          {
            headerName: this.$t('CargoMsg.Cargo_OperationRequirement'), colId: 'contentDescription', field: 'contentDescription', width: 750,
            editable: false
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Finished'),
            field: 'finished',
            suppressMenu: true,
            width: 150,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: !this.isEditing,
              tag: 'el-checkbox'
            }
          }
        ]
      },
      opGridParams: {},
      collapse: [0, 1, 2, 3, 4, 5],
      warehouseInInfo: null,
      delBusinessDocumentKeys: [], // 删除文件
      delWarehouseInDetailKeys: [], // 删除货物明细
      JobUtils
    }
  },
  computed: {
    isFba() { // 是否fba
      return this.lob === 'FBA'
    },
    readonly() {
      return !this.isEditing
    },
    detailListSelectedRow() {
      return this.form.warehouseInDetailList[this.detailList.goodGridOptions.selectedRowIndex]
    },
    photoListSelectedRow() {
      return this.form.businessDocumentVOList[this.photoList.gridOptions.selectedRowIndex]
    },
    isEditing() {
      return this.action !== 'look'
    },
    canNotEdit() {
      return false
    },
    destinations() { // 目的地 可选项
      return JobUtils.initDestination()
    }
  },
  watch: {
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.storageURL = cache.config.get('StorageURL')
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.documentTypeUtil = await DocumentTypeUtil.getInstance()
    },
    async onShow(row, isRefresh) {
      if (row.fbaPallets) { // 托盘数量=打托信息页签维护的托盘数量
        row.palletSum = row.fbaPallets.length || 0
      }
      if (!isRefresh) {
        return
      }
      this.form = row
      this.form.updateCargoDetail = false
      if (this.form.bubbleCountingRatio || typeof this.form.bubbleCountingRatio === 'number') {
        this.bubbleCountingRatio = Number(this.form.bubbleCountingRatio)
      } else {
        this.bubbleCountingRatio = 6000.0
      }
      this.initAddedService()
      this.calcEstJmt()
      this.calcActJmt()
      this.jobKeyOld = this.form.jobKey
      // 清空选中背景色
      if (this.detailList.gridApiEst) this.detailList.gridApiEst.clearFocusedCell()
      if (this.detailList.gridApi) this.detailList.gridApi.clearFocusedCell()
      if (this.photoList.gridApi) this.photoList.gridApi.clearFocusedCell()
      if (this.opList.gridApi) this.opList.gridApi.clearFocusedCell()
      if (this.isWeigh && this.isEditing) {
        if (!this.form.weighTime) { // 称重时间默认为当前时间
          this.form.weighTime = new Date()
        }
      }
    },
    initAddedService() {
      this.localAddedService = []
      this.podAddedService = []
      this.selectedLocalAddedService = []
      this.selectedPodAddedService = []
      // 初始化增值服务
      let valueAddedServices = []
      if (this.form.valueAddedServices && this.form.valueAddedServices.split(',').length > 0) {
        valueAddedServices = this.form.valueAddedServices.split(',')
      }
      const res = getSpecificBasicDataFromCache(this.selectTypeNames.basic_data_ValueAddedService)
      for (const item of res) {
        if ((this.form.shippingType === 'SE' && item.fbaSea) || (this.form.shippingType === 'AE' && item.fbaAir) || (this.form.shippingType === 'RE' && item.fbaRailway)) {
          switch (Number(item.serviceType)) {
            case 0:
              this.localAddedService.push(item)
              if (valueAddedServices.indexOf(item.code) >= 0) {
                this.form[item.code] = true
                this.selectedLocalAddedService.push(item.code)
              }
              break
            case 1:
              this.podAddedService.push(item)
              if (valueAddedServices.indexOf(item.code) >= 0) {
                this.form[item.code] = true
                this.selectedPodAddedService.push(item.code)
              }
              break
          }
        }
      }
    },
    toChooseFile(file) {
      if (file.size > 20 * 1024 * 1024) {
        this.$message.warning(this.$t('Message.TheExceeds20MBAndUploaded'))
        return
      }
    },
    // 上传成功
    uploadSuccess(response, file, fileList) {
      if (response && response.data) {
        const document = {}
        document.warehouseInUuid = response.data.warehouseInUuid
        document.createdBy = response.data.createdBy
        document.dateCreated = response.data.dateCreated
        document.documentCategory = response.data.documentCategory
        document.documentId = response.data.documentId
        document.fileName = response.data.fileName
        document.fileSize = response.data.fileSize
        document.fileType = response.data.fileType
        document.fileCategory = response.data.fileCategory
        document.newData = true
        document.updated = true
        this.form.businessDocumentVOList.push(document)
      } else {
        this.$message.warning(this.$t('Message.UploadPleaseContactTheAdministrator'))
      }
    },
    // 计算委托件毛体
    calcEstJmt() {
      // 委托
      this.form.quantityContract = 0
      this.form.weightContract = 0
      this.form.cubageContract = 0
      this.form.volumetricWeightContract = 0.0
      this.form.chargeWeightContract = 0.0
      const fbaJobGoods = this.form.fbaJobGoods || []
      if (fbaJobGoods && fbaJobGoods.length > 0) {
        for (const item of fbaJobGoods) {
          if (item.boxesNumber) {
            this.form.quantityContract += Number(item.boxesNumber)
          }
          if (item.weight) {
            this.form.weightContract += Number(item.weight)
          }
          if (item.boxLength && item.boxWidth && item.boxHeight) {
            const tempCubage = ((Number(item.boxLength) * Number(item.boxWidth) * Number(item.boxHeight)) / 1000000).toFixed(3)
            this.form.cubageContract += (Number(tempCubage) || 0)
            // 材积
            if (this.bubbleCountingRatio > 0) {
              const tmpVolumetricWeightContract = (((Number(item.boxLength) * Number(item.boxWidth) * Number(item.boxHeight)) / Number(this.bubbleCountingRatio)) * Number(item.boxesNumber)).toFixed(3)
              this.form.volumetricWeightContract += (Number(tmpVolumetricWeightContract) || 0)
            }
          }
        }
      }
      this.form.chargeWeightContract = Number(this.form.weightContract) > Number(this.form.volumetricWeightContract) ? this.form.weightContract : this.form.volumetricWeightContract
    },
    // 计算实际件毛体
    calcActJmt() {
      // 实际
      this.form.quantitySum = 0
      this.form.weightSum = 0
      this.form.cubageSum = 0
      this.form.volumetricWeightAct = 0.0
      this.form.chargeWeightAct = 0.0
      const warehouseInDetailList = this.form.warehouseInDetailList || []
      if (warehouseInDetailList && warehouseInDetailList.length > 0) {
        for (const item of warehouseInDetailList) {
          if (item.boxesNumber) {
            this.form.quantitySum += Number(item.boxesNumber)
          }
          if (item.weight) {
            this.form.weightSum += Number(item.weight)
          }
          if (item.boxLength && item.boxWidth && item.boxHeight) {
            const tempCubage = ((Number(item.boxLength) * Number(item.boxWidth) * Number(item.boxHeight)) / 1000000).toFixed(3)
            this.form.cubageSum += (Number(tempCubage) || 0)
            // 材积
            if (this.bubbleCountingRatio > 0) {
              const tmpVolumetricWeightAct = (((Number(item.boxLength) * Number(item.boxWidth) * Number(item.boxHeight)) / Number(this.bubbleCountingRatio)) * Number(item.boxesNumber)).toFixed(3)
              this.form.volumetricWeightAct += (Number(tmpVolumetricWeightAct) || 0)
            }
          }
        }
      }
      this.form.chargeWeightAct = Number(this.form.weightSum) > Number(this.form.volumetricWeightAct) ? this.form.weightSum : this.form.volumetricWeightAct
    },
    getSubmitData() {
      this.form.lob = this.form.lob === 'FBA' ? '' : this.form.lob
      this.form.fba = true
      this.form.branchId = this.$store.getters.currentOfficeId
      const fbaWarehouseInVO = { ...this.form }
      fbaWarehouseInVO.warehouseInDetail = []
      fbaWarehouseInVO.businessDocument = []
      const updatedWarehouseInDetailList = this.form.warehouseInDetailList.filter(p => p.updated)
      const warehouseInDetailList = [...updatedWarehouseInDetailList]
      const updatedBusinessDocumentList = this.form.businessDocumentVOList.filter(p => p.updated)
      const businessDocumentVOList = [...updatedBusinessDocumentList]
      return {
        fbaWarehouseInVO: fbaWarehouseInVO,
        warehouseInDetailList,
        delWarehouseInDetailKeys: this.delWarehouseInDetailKeys,
        businessDocumentVOList,
        delBusinessDocumentKeys: this.delBusinessDocumentKeys
      }
    },
    // 是否打托
    daycareInformationChangeHandler() {
      if (this.form.pallet && (!this.form.checklistStatus || Number(this.form.checklistStatus) !== 1)) {
        this.form.pallet = false
        this.$message.warning('订单未核单，请先进行核单操作。')
      }
      if (!this.form.pallet && this.form.fbaPallets && this.form.fbaPallets.length > 0) {
        this.form.pallet = true
        this.$message.warning('请先删除所有托盘。')
      }
    },
    checkboxChangeHandler() {
      if (!this.form.broken) {
        this.form.brokenQuantity = 0
      }
      if (!this.form.sealCargo) {
        this.form.sealWeight = 0
      }
    },
    // 加入货物
    addDetailHandler() {
      const detail = new FbaWarehouseInDetail().fillDefaultValue().getData()
      detail.warehouseInUuid = this.form.uuid
      detail.updated = true
      this.form.warehouseInDetailList.push(detail)
      this.calcActJmt()
    },
    // 删除货物
    delDetailHandler() {
      if (this.detailListSelectedRow) {
        // 数据库删除使用
        const detailUuid = this.detailListSelectedRow.uuid
        if (detailUuid && !this.delWarehouseInDetailKeys.includes(detailUuid)) {
          this.delWarehouseInDetailKeys.push(detailUuid)
        }
        const index = this.detailList.goodGridOptions.selectedRowIndex
        if (index > -1) {
          this.form.warehouseInDetailList.splice(index, 1)
        }
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
    },
    // 删除文件
    delPhotoHandler() {
      if (this.photoListSelectedRow) {
        // 数据库删除使用
        const detailUuid = this.photoListSelectedRow.uuid
        if (detailUuid && !this.delBusinessDocumentKeys.includes(detailUuid)) {
          this.delBusinessDocumentKeys.push(detailUuid)
        }
        const index = this.photoList.gridOptions.selectedRowIndex
        if (index > -1) {
          this.form.businessDocumentVOList.splice(index, 1)
        }
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
    },
    // 文件类型 编辑保存
    itemEditEndHandler(data) {
      if (data) {
        const list = []
        for (const p of this.form.businessDocumentVOList) {
          if (p.documentId === data.fileId) {
            p.fileCategory = data.fileCategory
            p.updated = true
          }
          list.push(p)
        }
        this.form.businessDocumentVOList = list
      }
    },
    // 检查委托和实际 箱数、单货箱重量、货箱长度、货箱宽度、货箱高度、托盘编号是否一致
    compareEstWarehouseInField(fieldName, current, targetList) {
      for (const e of targetList) {
        const sameItem = e.shipmentId === current.shipmentId && e.referenceId === current.referenceId &&
            e.cargoChineseName === current.cargoChineseName && e.cargoEnglishName === current.cargoEnglishName
        if (sameItem) {
          if (e[fieldName] === current[fieldName]) {
            return true
          }
        }
      }
      return false
    },
    selectJobNoHandler(data) {
      if (!data) {
        return
      }
      this.form.flightAndTime = ''
      getJobDetailFunc({ key: data }).then(res => {
        if (res.data) {
          this.clearJobData()
          this.jobKeyOld = this.form.jobKey
          Object.keys(this.form).forEach((key) => {
            if (res.data[key]) {
              this.form[key] = res.data[key]
            }
          })
          this.form.flightAndTime = this.voyageFlightStr()
        } else {
          this.$message.warning(this.$t('Message.FailedPleaseRefreshAndAgain'))
        }
      }).catch((err) => {
        this.$message.error(err)
        this.loading.close()
      })
    },
    // 根据进仓编号获取业务
    warehouseNoChargeHandler(data) {
      // 国外仓不能单独去关联业务，暂时屏蔽
      // setTimeout(() => {
      //   if (data === '') {
      //     return
      //   }
      //   this.loading = getLoading()
      //   this.filter.branchId = this.$store.getters.currentOfficeId
      //   this.filter.warehouseNo = this.form.warehouseNo
      //   this.filter.lob = this.lob
      //   queryJobByWarehouseNoFunc(this.filter).then(res => {
      //     this.loading.close()
      //     const j = res.data
      //     if (j === null || j.length === 0) {
      //       return
      //     }
      //     // 一个就直接用
      //     if (j.length === 1) {
      //       this.clearJobData()
      //       this.jobKeyOld = this.form.jobKey
      //       Object.keys(this.form).forEach((key) => {
      //         if (j[0][key]) {
      //           this.form[key] = j[0][key]
      //         }
      //       })
      //       this.form.flightAndTime = this.voyageFlightStr()
      //     } else {
      //       // 多个选一下
      //       this.jobNosWindow.visible = true
      //       this.jobNosWindow.jobs = res.data
      //     }
      //   }).catch((err) => {
      //     this.$message.error(err)
      //     this.loading.close()
      //   })
      // }, 100)
    },
    // 清理job相关数据
    clearJobData() {
      this.form.jobNo = ''
      this.form.etdString = ''
      this.form.loadingPortEnglish = ''
      this.form.mbl = ''
      this.form.carrierName = ''
      this.form.destinationPortEnglish = ''
      this.form.hbl = ''
      this.form.voyageFlight = ''
      this.form.customerName = ''
      this.form.quantityContract = 0
      this.form.weightContract = 0.00
      this.form.cubageContract = 0.000
    },
    onFileTypeCellFocused(event) {
      this.photoList.gridOptions.selectedRowIndex = event.rowIndex
      if (event.column && event.column && event.column.colId === 'fileCategory') {
        this.fileTypeEdit(this.form.businessDocumentVOList[event.rowIndex])
      }
    },
    fileTypeEdit(data) {
      if (data !== null && this.isEditing) {
        this.fileTypeEditor.fileId = data.documentId
        this.fileTypeEditor.fileCategory = data.fileCategory
        this.fileTypeEditor.visible = true
      }
    },
    suppressKeyboardEvent(param) {
      const currInput = param.event.target.attributes['data-index']
      if (currInput) {
        if (param.event.keyCode === 9 && currInput.value === 'sizeQuantity') {
          return false
        }
      }
      return true
    },
    // 批量维护
    batchMaintenance() {

    },
    // 批量导入
    batchImport() {

    },
    // 按客户数据拣货
    pickingGoods() {

    },
    // 调整计费重量
    adjustChargeWeight() {

    },
    // 清空
    clearData() {

    },
    // 列编辑
    onCellChange(params) {
      this.form.updateCargoDetail = true
      const fbaWarehouseInDetail = params.data
      fbaWarehouseInDetail.updated = true
      this.calcActJmt()
    }
  }
}
</script>

<style lang="scss">
.warehousing-detail {
  .custom-textarea{
    textarea{
      height: 64px;
    }
  }
  .el-collapse {
    &-item {
      &__header {
        padding: 0 15px;
        border-bottom: none;
        color: #4283ff;
        font-weight: bold;
        background-color: #fff;
      }
      &__wrap {
        padding: 15px;
        border-bottom: none;
        background-color: #f0f3f8!important;
      }
      &__arrow {
        color: #303133;
      }
    }
  }
  .spacing {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .grid-list {
    flex-direction:row;
    width: 80%;
    max-width: 950px;
    min-width: 950px;
  }

  .required .el-form-item__label {
    color: #1F75D5!important
  }
}
</style>
